<template>
    <div class="modelDownload">
        <div class="listSearchBox">
            <el-input v-model="modelName" placeholder="模型名称"></el-input>
            <el-select v-model="firstClassifyName" placeholder="一级分类">
                <el-option
                    label="一级分类1"
                    value="一级分类1">
                </el-option>
                <el-option
                    label="一级分类2"
                    value="一级分类2">
                </el-option>
                <el-option
                    label="一级分类3"
                    value="一级分类3">
                </el-option>
            </el-select>
            <el-select v-model="secondClassifyName" placeholder="二级分类">
                <el-option
                    label="二级分类"
                    value="二级分类">
                </el-option>
                <el-option
                    label="二级分类"
                    value="二级分类">
                </el-option>
                <el-option
                    label="二级分类"
                    value="二级分类">
                </el-option>
            </el-select>
            <el-select v-model="publishStatus" placeholder="发布状态">
                <el-option
                    label="已发布"
                    value="已发布">
                </el-option>
                <el-option
                    label="未发布"
                    value="未发布">
                </el-option>
            </el-select>
            <el-select v-model="supportDownload" placeholder="下载/预览">
                <el-option
                    label="下载"
                    value="下载">
                </el-option>
                <el-option
                    label="仅预览"
                    value="仅预览">
                </el-option>
            </el-select>
            <el-button class="searchBtn">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="listTableBox">
            <div class="tableTool">
                <div class="toolLeft">
                    <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="publish('all')">批量发布</el-button>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0" @click="del('all')">批量删除</el-button>
                    <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0">批量下载</el-button>
                </div>
                <div class="toolRight">
                    <el-button type="primary" size="small" @click="toDialog('add')">上传模型</el-button>
                </div>
            </div>
            <div class="tableContent">
                <ul class="tableHeader">
                    <li class="select"><el-checkbox v-model="tableHeaderCheck" @change="tableHeaderChange"></el-checkbox></li>
                    <li class="name">模型名称</li>
                    <li class="classify">一级分类</li>
                    <li class="classify">二级分类</li>
                    <li class="status">下载量 <i class="el-icon-bottom"></i></li>
                    <li class="status">访问量 <i class="el-icon-bottom"></i></li>
                    <li class="status">金额</li>
                    <li class="status">状态</li>
                    <li class="status">下载/预览</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody">
                    <li class="bodyItem" v-for="(item,index) in tableListData" :key="index">
                        <div class="itemTop">
                            <el-checkbox v-model="item.checked" @change="bodyItemCheckChange"></el-checkbox>
                            <span>上传时间：{{item.createDate}}</span>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <img :src="item.url" alt="">
                                <span>{{item.name}}</span>
                            </div>
                            <div class="classify">{{item.firstClassify}}</div>
                            <div class="classify">{{item.secondClassify}}</div>
                            <div class="status">{{item.downloadNum}}</div>
                            <div class="status">{{item.pageView}}</div>
                            <div class="status">{{item.price}}</div>
                            <div class="status">{{item.state}}</div>
                            <div class="status">{{item.isDownload}}</div>
                            <div class="operation">
                                <el-button type="text" size="small" @click="toDialog('edit',item.uuid)">编辑</el-button>
                                <el-button type="text" size="small" @click="publish(item.uuid)">发布</el-button>
                                <el-button type="text" size="small">下载</el-button>
                                <el-button type="text" size="small" @click="del(item.uuid)">删除</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <model-management-dialog  ref="dialogRef" @submit="init"></model-management-dialog>
    </div>
</template>

<script>
    import modelManagementDialog from './modelManagementDialog'
    export default {
        name: "modelDownload",
        data(){
            return{
                modelName: '',
                firstClassifyName: '',
                secondClassifyName: '',
                publishStatus: '',
                supportDownload: '',
                tableHeaderCheck: false,
                tableListData: [
                    {
                        uuid: '0',
                        checked: false,
                        url: require('@/assets/images/13哆啦A梦.png'),
                        name: '创意座椅',
                        firstClassify: '家居用品',
                        secondClassify: '家具',
                        downloadNum: '100',
                        pageView: '300',
                        price: '免费',
                        state: '已下架',
                        isDownload: '仅预览',
                        createDate: '2021/08/02 13:37:25'
                    },
                    {
                        uuid: '1',
                        checked: false,
                        url: require('@/assets/images/13哆啦A梦.png'),
                        name: '创意座椅',
                        firstClassify: '家居用品',
                        secondClassify: '家具',
                        downloadNum: '100',
                        pageView: '300',
                        price: '免费',
                        state: '已下架',
                        isDownload: '仅预览',
                        createDate: '2021/08/02 13:37:25'
                    },
                    {
                        uuid: '2',
                        checked: false,
                        url: require('@/assets/images/13哆啦A梦.png'),
                        name: '创意座椅',
                        firstClassify: '家居用品',
                        secondClassify: '家具',
                        downloadNum: '100',
                        pageView: '300',
                        price: '免费',
                        state: '已下架',
                        isDownload: '仅预览',
                        createDate: '2021/08/02 13:37:25'
                    },
                    {
                        uuid: '3',
                        checked: false,
                        url: require('@/assets/images/13哆啦A梦.png'),
                        name: '创意座椅',
                        firstClassify: '家居用品',
                        secondClassify: '家具',
                        downloadNum: '100',
                        pageView: '300',
                        price: '免费',
                        state: '已下架',
                        isDownload: '仅预览',
                        createDate: '2021/08/02 13:37:25'
                    },
                    {
                        uuid: '4',
                        checked: false,
                        url: require('@/assets/images/13哆啦A梦.png'),
                        name: '创意座椅',
                        firstClassify: '家居用品',
                        secondClassify: '家具',
                        downloadNum: '100',
                        pageView: '300',
                        price: '免费',
                        state: '已下架',
                        isDownload: '仅预览',
                        createDate: '2021/08/02 13:37:25'
                    }
                ],
                multipleSelection: [],
                pageNo: 1,
                total: 0,
                pageSize: 4
            }
        },
        components: {
            modelManagementDialog
        },
        methods: {
            init(){
                this.reset()
            },
            // 检索重置
            reset(){
                this.modelName = ''
                this.firstClassifyName = ''
                this.secondClassifyName = ''
                this.publishStatus = ''
                this.supportDownload = ''
            },
            // 分页
            handleCurrentChange(val){
                this.pageNo = val
            },
            // 列表选择功能
            tableHeaderChange(val){
                this.tableListData.map(item=>{
                    item.checked = val
                })
                if(val){
                    this.multipleSelection = this.tableListData
                } else {
                    this.multipleSelection = []
                }
            },
            bodyItemCheckChange(val){
                this.multipleSelection = this.tableListData.filter(res => res.checked === true)
                if(this.multipleSelection.length === this.tableListData.length){
                    this.tableHeaderCheck = true
                } else {
                    this.tableHeaderCheck = false
                }
            },
            // 编辑/新增
            toDialog(type,id){
                this.$refs.dialogRef.init(type,id)
            },
            // 删除
            del(val){
                let ids = ''
                if(val === 'all'){
                    ids = this.multipleSelection.map((item)=>{
                        return item.uuid
                    }).toString()
                } else {
                    ids = val
                }
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功！'
                    })
                    this.multipleSelection = []
                }).catch(() => {})
            },
            // 发布
            publish(val){
                let ids = []
                if(val === 'all'){
                    this.multipleSelection.map((item)=>{
                        if(item.state === '已下架'){
                            ids.push(item.uuid)
                        }
                    })
                } else {
                    ids.push(val)
                }
                this.$confirm('确定要发布吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '发布成功！'
                    })
                    this.multipleSelection = []
                }).catch(() => {})
            },
        }
    }
</script>

<style scoped lang="less">
.modelDownload{
    padding:20px;
    .listSearchBox {
        display: flex;
        flex-wrap: wrap;
        
        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }
        
        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;
            
            &:hover, &:focus {
                background-color: #fff;
                border: 1px solid #108EE9;
            }
        }
        
        /deep/ .el-input__prefix {
            top: -3px;
        }
        
        /deep/ .el-input__suffix {
            top: 2px;
        }
        
        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }
        
        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom:22px;
        }
        
        .resetBtn {
            color: #333333;
            margin-bottom:22px;
        }
    }
    .listTableBox{
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        
            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);
            
                .num {
                    color: #356FDF;
                }
            
                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157EFB;
                    line-height: 30px;
                    text-align: center;
                
                    &:hover {
                        background: #157EFB;
                        box-sizing: border-box;
                        border: 1px solid #157EFB;
                        color: #fff;
                    }
                }
            }
        
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;
                
                    i {
                        padding-right: 5px;
                    }
                
                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .tableContent{
            // min-width: 1535px;
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f2f4f9;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    padding: 0 10px;
                    font-size: 14px;
                    color: #333333;
                    white-space: nowrap;
                }
            }
            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #333333;
                    margin-bottom: 10px;
                    .itemTop {
                        width: 100%;
                        height: 36px;
                        background: #f2f4f9;
                        line-height: 36px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 10px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        span{
                            padding-left: 20px;
                        }
                    }
                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;
                        padding: 10px 0;
                        .name{
                            padding-left: 44px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            img{
                                width: 132px;
                                height: 90px;
                                vertical-align: middle;
                            }
                            span{
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }
            .name {
                flex: 1;
                text-align: left;
            }
            .classify{
                width: 180px;
                text-align: center;
            }
            .status {
                width: 150px;
                text-align: center;
            }
            .operation {
                width: 300px;
                text-align: center;
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/model/modelUpload.vue